import { generateRegistrationYearOptions } from "./bikeUtils";
import { QuestionOption } from "@utils/bike/types";

export const PRIMARY_ACCENT = {
  LIGHTER: "#E4F9E5",
  LIGHT: "#37C87E",
  NORMAL: "#44CB86",
  DARK: "#00A871"
};

export const TEXT_COLOR = {
  LIGHTEST: "#B0B1C4",
  LIGHTER: "#555A68",
  LIGHT: "#414A53",
  NORMAL: "#5D607C",
  DARK: "#282E33",
  DARKER: "#0B0E34"
};

export const BORDER_COLORS = {
  LIGHTER: "#F4F5F7",
  LIGHT: "#DCDCE0",
  NORMAL: "#C8D0DB"
};

export const LINK_ACCENT = "#0091DD";
export const LINK_ACCENT_2 = "#1C73E8";
export const ERROR_ACCENT = "#E50031";
export const PURPLE_ACCENT = "#7C47E1";

export const REGISTRATION_YEARS = generateRegistrationYearOptions();

export const BIKE_PA_COVER_ID = "pa_owner_two_wheeler";
export const BIKE_TP_PLAN = "bike_tp";
export const TP_UTM_CONTENT = "TP";
export const BIKE_COMPREHENSIVE_PLAN = "bike_comprehensive";
export const SELECT_BIKE_LABEL = "Choose Bike Model";
export const SELECT_BIKE_PLACEHOLDER = "Search your bike";
export const REGISTRATION_YEAR_LABEL = "Bike Bought in";
export const MOBILE_NUMBER_LABEL = "Your mobile number";
export const REGISTRATION_YEAR_PLACEHOLDER = "Select Year";
export const POLICY_STATUS_LABEL = "Current Policy Status";
export const POLICY_STATUS_PLACEHOLDER = "Expired or not";
export const BIKE_OD_POLICY_STATUS_TEXT =
  "Provide own damage plan expiry status";

export const EXPIRED_POLICY_STATUS_90_DAYS = "90-";

export const ERROR_MESSAGE = "Oops! You missed providing some information.";

export const QUICK_STEPS_HEADING = "3 quick steps to get your policy";
export const QUICK_STEPS = [
  "Tell us about your bike",
  "Get personalized low prices",
  "Pay & get policy instantly"
];

export const POLICY_EXPIRY_OPTIONS: QuestionOption[] = [
  {
    name: "Not Expired",
    value: "0",
    buttonId: "notExpired"
  },
  {
    name: "Expired in the last 90 days",
    value: "0-90",
    buttonId: "expiredL90"
  },
  {
    name: "Expired more than 90 days ago",
    value: "90-",
    buttonId: "expiredG90"
  }
];

export const OD_PREVIOUS_POLICY_EXPIRY_OPTIONS = [
  {
    name: "Policy not expired",
    value: "false",
    buttonId: "notExpired"
  },
  {
    name: "Policy expired",
    value: "true",
    buttonId: "expired"
  }
];

export const FUSE_OPTIONS = {
  keys: ["name", "variants.verbose"]
};

export const HEADING_PREFIX = {
  SINGLEPLAN: "Plan for your",
  MULTIPLEPLANS: "Plans for your"
};
export const REGISTRATION_YEAR_LABEL_PLAN = "Bought:";
export const POLICY_EXPIRY_LABEL = "Policy";
export const NCB_LABEL = "New NCB:";
export const POLICY_EXPIRY = {
  EXPIRED: "Expired",
  NOT: "Not Expired"
};

export const plans_mapping = {
  bike_comprehensive: {
    displayName: "Comprehensive",
    description: "Covers damage to your bike and others"
  },
  bike_tp: {
    displayName: "Third party",
    description: "Covers damage to others' property"
  }
};

export const slot_details = [
  {
    date: "2023-07-19",
    day_data: {
      day: "Wednesday",
      time_slot: [
        {
          display: "06:30 AM - 07:00 AM",
          slot_id: 1457332,
          selected: false
        },
        {
          display: "07:00 AM - 07:30 AM",
          slot_id: 1457169,
          selected: false
        },
        {
          display: "08:00 AM - 08:30 AM",
          slot_id: 1457181,
          selected: false
        },
        {
          display: "09:00 AM - 09:30 AM",
          slot_id: 1457173,
          selected: false
        },
        {
          display: "10:30 AM - 11:00 AM",
          slot_id: 1457186,
          selected: false
        },
        {
          display: "11:30 AM - 12:00 PM",
          slot_id: 1457151,
          selected: false
        },
        {
          display: "12:30 PM - 01:00 PM",
          slot_id: 1457164,
          selected: false
        },
        {
          display: "01:00 PM - 01:30 PM",
          slot_id: 1457191,
          selected: false
        },
        {
          display: "01:30 PM - 02:00 PM",
          slot_id: 1457209,
          selected: false
        },
        {
          display: "02:00 PM - 02:30 PM",
          slot_id: 1457195,
          selected: false
        },
        {
          display: "02:30 PM - 03:00 PM",
          slot_id: 1457153,
          selected: false
        },
        {
          display: "03:00 PM - 03:30 PM",
          slot_id: 1457170,
          selected: false
        },
        {
          display: "03:30 PM - 04:00 PM",
          slot_id: 1457208,
          selected: false
        },
        {
          display: "04:00 PM - 04:30 PM",
          slot_id: 1457330,
          selected: false
        },
        {
          display: "05:00 PM - 05:30 PM",
          slot_id: 1457339,
          selected: false
        },
        {
          display: "05:30 PM - 06:00 PM",
          slot_id: 1457185,
          selected: false
        },
        {
          display: "06:00 PM - 06:30 PM",
          slot_id: 1457177,
          selected: false
        },
        {
          display: "06:30 PM - 07:00 PM",
          slot_id: 1457326,
          selected: false
        },
        {
          display: "07:00 PM - 07:30 PM",
          slot_id: 1457216,
          selected: false
        },
        {
          display: "07:30 PM - 08:00 PM",
          slot_id: 1457179,
          selected: false
        },
        {
          display: "08:00 PM - 08:30 PM",
          slot_id: 1457165,
          selected: false
        },
        {
          display: "08:30 PM - 09:00 PM",
          slot_id: 1457398,
          selected: false
        },
        {
          display: "09:00 PM - 09:30 PM",
          slot_id: 1457325,
          selected: false
        },
        {
          display: "09:30 PM - 10:00 PM",
          slot_id: 1457161,
          selected: false
        },
        {
          display: "10:00 PM - 10:30 PM",
          slot_id: 1457184,
          selected: false
        },
        {
          display: "10:30 PM - 11:00 PM",
          slot_id: 1457171,
          selected: false
        },
        {
          display: "11:00 PM - 11:30 PM",
          slot_id: 1457163,
          selected: false
        },
        {
          display: "11:30 PM - 12:00 AM",
          slot_id: 1457160,
          selected: false
        }
      ]
    }
  },
  {
    date: "2023-07-20",
    day_data: {
      day: "Thursday",
      time_slot: [
        {
          display: "08:00 AM - 08:30 AM",
          slot_id: 1457480,
          selected: false
        },
        {
          display: "08:30 AM - 09:00 AM",
          slot_id: 1457419,
          selected: false
        },
        {
          display: "09:00 AM - 09:30 AM",
          slot_id: 1457656,
          selected: false
        },
        {
          display: "10:30 AM - 11:00 AM",
          slot_id: 1457508,
          selected: false
        },
        {
          display: "12:30 PM - 01:00 PM",
          slot_id: 1457559,
          selected: false
        },
        {
          display: "01:30 PM - 02:00 PM",
          slot_id: 1457435,
          selected: false
        },
        {
          display: "02:00 PM - 02:30 PM",
          slot_id: 1457422,
          selected: false
        },
        {
          display: "02:00 PM - 02:30 PM",
          slot_id: 1457513,
          selected: false
        },
        {
          display: "02:00 PM - 02:30 PM",
          slot_id: 1457634,
          selected: false
        },
        {
          display: "02:30 PM - 03:00 PM",
          slot_id: 1457642,
          selected: false
        },
        {
          display: "03:00 PM - 03:30 PM",
          slot_id: 1457547,
          selected: false
        },
        {
          display: "03:30 PM - 04:00 PM",
          slot_id: 1457447,
          selected: false
        },
        {
          display: "04:00 PM - 04:30 PM",
          slot_id: 1457558,
          selected: false
        },
        {
          display: "04:30 PM - 05:00 PM",
          slot_id: 1457413,
          selected: false
        },
        {
          display: "05:00 PM - 05:30 PM",
          slot_id: 1457557,
          selected: false
        },
        {
          display: "05:30 PM - 06:00 PM",
          slot_id: 1457511,
          selected: false
        },
        {
          display: "06:30 PM - 07:00 PM",
          slot_id: 1457440,
          selected: false
        },
        {
          display: "08:00 PM - 08:30 PM",
          slot_id: 1457560,
          selected: false
        },
        {
          display: "08:30 PM - 09:00 PM",
          slot_id: 1457449,
          selected: false
        },
        {
          display: "09:00 PM - 09:30 PM",
          slot_id: 1457477,
          selected: false
        },
        {
          display: "09:30 PM - 10:00 PM",
          slot_id: 1457639,
          selected: false
        },
        {
          display: "10:45 PM - 11:00 PM",
          slot_id: 1457597,
          selected: false
        },
        {
          display: "11:00 PM - 11:30 PM",
          slot_id: 1457414,
          selected: false
        },
        {
          display: "11:30 PM - 12:00 AM",
          slot_id: 1457452,
          selected: false
        }
      ]
    }
  }
];
